import { Loader2, Check, Wrench } from "lucide-react"
import { TOOL_LABELS } from "@/lib/ai-types"

interface AiToolCallCardProps {
  toolName: string
  status: "running" | "done"
}

export function AiToolCallCard({ toolName, status }: AiToolCallCardProps) {
  const label = TOOL_LABELS[toolName] || toolName

  return (
    <div className="my-1 flex items-center gap-2 rounded-lg border border-border bg-muted/30 px-3 py-1.5 text-xs text-muted-foreground">
      {status === "running" ? (
        <Loader2 size={12} className="animate-spin text-primary" />
      ) : (
        <Check size={12} className="text-green-500" />
      )}
      <Wrench size={11} className="opacity-50" />
      <span>{label}</span>
    </div>
  )
}
